// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"4397745f","462":"2faae3e1","520":"1c5560fb","873":"92ac1959","926":"b17f263e"}[chunkId] + ".chunk.js";
};